var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":_vm.appColor,"app":"","dark":""}},[_c('span',[_vm._v("King's University College")]),_c('v-spacer'),_c('span',[_vm._v("© 2020")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }